module.exports = __webpack_public_path__ + "img/SS_V_Gold_FA_Colorless.5118392e.png";